export default "__VITE_ASSET__lkQT$K$k__"